import React from 'react';
import './App.css';
import Routers from './routers/Route';

function App() {
  return <Routers />;
}

export default App;
